module.exports = __webpack_public_path__ + "assets/close-icon-white-background-c782b8.svg";